export const parseNumber = ( num : string, is_float? : boolean ) => {
	if ( is_float )
	{
		return parseFloat( num );
	}
	
	num += ``;

	if ( num.indexOf(`.`) !== -1 )
	{
		num = num.split(`.`)[0];
	}

	num.replace( /\D/g, `` );

	return parseInt( num );
};



// WEBPACK FOOTER //
// ./app/utils/parseNumber.ts